import { MultiFileDropZoneSkeleton } from '@dealstack/frontend/shared/components/MultiFileDropZone/MultiFileDropZoneSkeleton';

export const FileDropSkeletons = () => {
	const batchSize = 10;

	return (
		<>
			{Array.from({ length: batchSize }, (_, index) => (
				<MultiFileDropZoneSkeleton key={index} />
			))}
		</>
	);
};
